<template>
  <div class="content">
    <img style="width: 500px;" src="../assets/404.png" />
    <div>
      <h1>OOPS!</h1>
      <h2>{{ $t('main_login_no_exist_page') }}</h2>
      <p style="font-size: 16px;">{{ $t('main_login_no_exist_page_tip') }}</p>
      <el-button type="primary" @click="handleBack">
        {{ backRoute && backRoute.routeUrl ? $t('main_login_no_last_back') : $t('main_login_no_exist_back') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { $t } from '@/lang'
export default defineComponent({
  name: '404',
  setup () {
    const router = useRouter()
    const store = useStore()

    const backRoute = store.state.menu.backRoute

    const handleBack = () => {
      if (backRoute && backRoute.routeUrl) {
        router.push(backRoute.routeUrl)
        store.commit('menu/setCurrentTab', {
          name: backRoute?.name,
          routeUrl: backRoute.routeUrl
        })
      } else {
        router.push('/')
        store.commit('menu/setCurrentTab', {
          name: $t('main_home_home_name'),
          routeUrl: '/'
        })
      }
    }

    return {
      handleBack,
      backRoute
    }
  }
})
</script>

<style lang='scss' scoped>
.content {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
